import { render, staticRenderFns } from "./RemovePartsConfirmation.vue?vue&type=template&id=f0996980"
import script from "./RemovePartsConfirmation.ts?vue&type=script&lang=ts&external"
export * from "./RemovePartsConfirmation.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports